<script setup lang="ts">
/**
 * Any change must be replicated in the twig file and in search
 * @see templates/components/match-pictures.html.twig
 * @see match-search:src/components/MatchPictures.vue
 */
import MediaImage from '@components/MediaImage.vue';
import { computed } from 'vue';

const { size = 48 } = defineProps<{
  size?: number,
}>();

const computedBorderWidth = computed<number>(() => Math.round(size / 24));

const borderWidth = computed<number>(() => (computedBorderWidth.value % 2 === 0 ? computedBorderWidth.value : computedBorderWidth.value + 1));

const negativeGap = computed<number>(() => Math.round(size / 4));

const personas = [
  {
    alt: 'Chloe',
    hash: '4720fe23-303b-4fc1-9c76-ad0cf2efcfb5',
  },
  {
    alt: 'Mehdi',
    hash: 'b4d67623-5d71-49d9-bc7f-a67c4a86f493',
  },
  {
    alt: 'Simon',
    hash: '8aba5a1d-d5fb-4a9d-9621-b0179aa2c807',
  },
];
</script>

<template>
  <div
    class="match-pictures"
  >
    <div
      v-for="(persona, index) in personas"
      :key="persona.hash"
      class="picture"
      :style="{
        borderWidth: `${borderWidth}px`,
        marginLeft: index ? `-${negativeGap}px` : 0,
      }"
    >
      <MediaImage
        :uuid="persona.hash"
        :alt="persona.alt"
        :width="size"
        :height="size"
        :density="3"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/_02_molecules/components/match-pictures';

.match-pictures {
  .picture {
    :deep(img) {
      display: flex;
    }
  }
}
</style>
